export * from './src/loyalty-referral-v1-referral-reward-rewards.universal.js';
